import React from 'react';
import { createSvgIcon } from './utils/createSvgIcon';
import { aibTheme } from '~/uikit/Theme/Theme';

const colors = aibTheme.palette;

export const IconLeftArrow = createSvgIcon(
  'left-arrow',
  <g>
    <path
      d="M12 19.5L5 12.5L12 5.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M19 12.5H5" strokeLinecap="round" strokeLinejoin="round" />
  </g>,
  24,
  24,
  colors.secondary.semilight,
  'transparent'
);
